module.exports = __webpack_public_path__ + "static/media/oea.444ad05e.jpg";